module.exports = __webpack_public_path__ + "static/media/full-screen-image-3.b9b3b654.jpg";